import { z } from 'zod';
export const BusinessType = z.enum([
    'service_provider',
    'local_business',
    'b2b',
    'ecommerce',
    'nonprofit',
    'other',
]);
export const Audience = z.enum([
    'business_owners',
    'consumers',
    'specific_professionals',
    'local_community',
    'other',
]);
export const Goal = z.enum([
    'brand_awareness',
    'lead_gen',
    'top_of_mind',
    'thought_leadership',
    'promote_offer',
    'all_of_above',
]);
export const Platform = z.enum(['linkedin', 'instagram', 'facebook']);
export const Tone = z.enum([
    'friendly',
    'professional',
    'warm',
    'bold',
    'educational',
]);
export const ContentProfile = z
    .object({
    businessType: BusinessType,
    businessTypeOther: z.string().max(200).optional(),
    audience: Audience,
    audienceOther: z.string().max(200).optional(),
    goal: Goal,
    platforms: z.array(Platform).min(1),
    tone: Tone,
    avoid: z.string().max(500).optional(),
    great8: z.string().max(20000).optional(),
    // A short, free-text description in the user's own words. The highest-signal
    // intake field, especially when no Great 8 is provided.
    businessDescription: z.string().max(500).optional(),
})
    .refine((p) => p.businessType !== 'other' || (p.businessTypeOther && p.businessTypeOther.trim().length > 0), { message: 'businessTypeOther is required when businessType is "other"', path: ['businessTypeOther'] })
    .refine((p) => p.audience !== 'other' || (p.audienceOther && p.audienceOther.trim().length > 0), { message: 'audienceOther is required when audience is "other"', path: ['audienceOther'] });
//# sourceMappingURL=profile.js.map